import { createContext } from "react"

export const SelectedTenantContext = createContext<{selectedTenant: string}>({ selectedTenant: ""});